import React, { useRef, useState } from 'react';
import './TenantVerificationForm.scss';
import { useLocation, useNavigate } from 'react-router-dom';
import logoBlack from "../../assets/images/hrPolic.png"
import PrintBtn from './PrintByt';
import { cleanName, extractAddressParts } from '../../utils/common';




const TenantVerificationForm = () => {
  const [count, setCount] = useState(["", ""])
  const location = useLocation();
  const user = location.state;
  const printRef = useRef();


  const handlePrint = async () => {
    window.print();


  };

  function calculateAge(dobString) {
    const dob = new Date(dobString); // Format: YYYY-MM-DD or MM/DD/YYYY
    const today = new Date();

    let age = today.getFullYear() - dob.getFullYear();
    const m = today.getMonth() - dob.getMonth();

    if (m < 0 || (m === 0 && today.getDate() < dob.getDate())) {
      age--;
    }

    return age;
  }
  const navigate = useNavigate();
  const handleClick = () => {

    navigate('/Rental-manager', {
      state: { mobileNumber: user?.tenantUserName },
    })
  }


  const { city = "", state = "", addressLine = "", locality = "", postalCode = "", ownerName = "", ownerParentName = "", contactNumber = "", policeStation = "" } = user?.accommodationDetail ?? {};
  const localRefs = user?.localRefs || "";
  const localRefNumber = localRefs.split(",")

  const docList = user?.docList || [];

  const tenantDoc = docList.find(item => (item?.docName || "").toLowerCase() === "tenant photo");

  const [permanentAddress, state1, District] = extractAddressParts(user?.permanentAddress || "")


  return (
    <div className='verificationForm main_containe' style={{ paddingInline: "20px" }}>

      <div className="flex gap-10 noPrint" style={{ cursor: "pointer" }} onClick={handleClick}>
        <div
          className="noPrint"
          style={{ cursor: "pointer" }}
        ><i className="fa-solid fa-arrow-left"></i></div>
        <strong>Back</strong>

      </div>

      <div>


        <div className="form-container" ref={printRef}>
          <PrintBtn />
          <div className='flex ' style={{}}>
            <img src={logoBlack} alt="" style={{ width: "60px", marginRight: "20px", marginLeft: "80px", display: "block" }} />
            <div>

              <h2 className="title">Gurugram Police</h2>
              <h3>Information on Domestic Help/Tenant/Employee</h3>
            </div>

          </div>

          <table className="form-table">
            <tbody>
              <tr>
                <th colSpan="4">Particulars of Employer / Landlord</th>
              </tr>

              <tr>
                <td style={{ width: "252px" }} className='heading'><span className='bold'>1.</span> Sector /Village/Colony/Society</td>
                <td contentEditable={true} className="fromValue">{locality || ""}</td>

                <td rowSpan="7" className={`photo-cell ${tenantDoc?.docLink ? "img-photo-cell" : ""}`}>
                  <div className="photo-placeholder">
                    {
                      tenantDoc?.docLink ? <img src={tenantDoc?.docLink} alt={tenantDoc?.docName} /> : "Photo"
                    }
                  </div>
                  <div className="div signatureBox"></div>
                  <span className='small'>Signature of the applicant</span>
                </td>
              </tr>
              <tr>
                <td className='heading '><span className='bold'>2.</span>.Plot No./Flat No./House No./Street No./Police Station</td>
                <td colSpan="2" className='removePadding'><div style={{ maxWidth: "258px", minHeight: "100%" }} contentEditable={true} className="fromValue">{` ${addressLine ? addressLine + "," : ""}`}</div></td>
              </tr>
              <tr>
                <td colSpan="2" className='heading'><span className='bold'>3.</span>.Name & Father's name of Employer/Landlord with Mobile No.</td>

              </tr>
              <tr>
                <td className='heading'><span style={{ textTransform: "lowercase", color: "#000" }}>i</span>) Name of the Landlord/Employer</td>
                <td colSpan="2" className='removePadding' ><div contentEditable={true} className="fromValue" style={{ maxWidth: "358px", minHeight: "100%" }} >{ownerName || ""}</div></td>
              </tr>
              <tr>
                <td className='heading'><span style={{ textTransform: "lowercase", color: "#000" }}>ii</span>)Father's Name</td>
                <td colSpan="2" className='removePadding'> <div contentEditable={true} className="fromValue" style={{ maxWidth: "358px", minHeight: "100%" }}>{ownerParentName || ""}</div></td>
              </tr>
              <tr>
                <td className='heading'><span style={{ textTransform: "lowercase", color: "#000" }}>iii</span>) Contact No.</td>
                <td colSpan="2" className='removePadding' ><div contentEditable={true} className="fromValue" style={{ maxWidth: "358px", minHeight: "100%" }}> {contactNumber || ""}</div></td>
              </tr>
            </tbody>
          </table>


          <table className="form-table">

            <tbody>

              <tr><th colSpan="4"><span className='bold'>4.</span>Particulars of Tenant/Employee/Domestic Help</th></tr>
              <tr>
                <td className='heading' style={{ width: "120px" }}>Full Name Alias</td>
                <td contentEditable={true} className="fromValue">{user?.tenantFullName || ""}</td>
                <td className='heading' style={{ width: "120px" }}>Phone No.</td>
                <td contentEditable={true} className="fromValue">{user?.mobileNumber || ""}</td>
              </tr>
              <tr>

                <td className='heading'>Father's Name</td>
                <td colSpan="3" contentEditable={true} className="fromValue">{cleanName(user?.careOf || "")}</td>
                {/* <td className='heading'>Email Id</td>
                <td contentEditable={true} className="fromValue">{user?.emailId }</td> */}

              </tr>
              <tr>

                <td className='heading'>Spouse Name</td>
                <td contentEditable={true} className="fromValue">{ }</td>
                <td className='heading'>Occupation</td>
                <td contentEditable={true} className="fromValue">{user?.occupation || ""}</td>

              </tr>

              <tr>
                <td className='heading'>Nationality </td>
                <td contentEditable={true} className="fromValue">India</td>
                <td className='heading'>Age</td>
                <td contentEditable={true} className="fromValue">{user?.dob ? calculateAge(user?.dob) : ""}</td>
              </tr>
              <tr>
                <td className='heading'>Sex</td>
                <td contentEditable={true} className="fromValue">{`${user?.gender ? user?.gender === "M" ? "Male" : user?.gender === "F" ? "Female" : "Other" : "-"}`}</td>
                <td className='heading'>Caste</td>
                <td contentEditable={true} className="fromValue">Hindu</td>
              </tr>

            </tbody>
          </table>


          <table className="form-table">

            <tbody>

              <tr><th colSpan="4"><span className='bold'>5.</span> Permanent Address</th></tr>
              <tr>
                <td className='heading' style={{ width: "185px" }}>House No.</td>
                <td colSpan="3" contentEditable={true} className="fromValue"></td>

              </tr>
              <tr>
                <td className='heading'>Sector/Village/Locality</td>
                <td colSpan="3" contentEditable={true} className="fromValue">{permanentAddress || ""}</td>
              </tr>
              <tr>
                <td className='heading'>Police Station</td>
                <td colSpan="3" contentEditable={true} className="fromValue"></td>
              </tr>

              <tr>
                <td className='heading'>District & State</td>
                <td contentEditable={true} className="fromValue" colSpan="3" >
                  {`${District ? District + "," : ""}  ${state1 || ""}`}
                </td>

              </tr>


              <tr>
                <td className='heading'>Landline / Mobile No.</td>
                <td colSpan="3" contentEditable={true} className="fromValue">{user?.mobileNumber || ""}</td>
              </tr>
              <tr>
                <td colSpan="3" className='removePadding'><div style={{ display: "flex" }}>
                  <div className='heading'>Proof of Idientity (Voter card/Driving License/Ration Card etc.)</div><p contentEditable={true} className="fromValue" style={{ flex: "1 1", marginLeft: "10px" }}></p>
                </div></td>

              </tr>

              <tr>
                <td className='heading' rowSpan={2} >Two References From Native Place(Name, Address & Ph No.)</td>
                <td colSpan="3" contentEditable={true} className="fromValue">1.</td>

              </tr>
              <tr>

                <td colSpan="3" contentEditable={true} className="fromValue">2.</td>

              </tr>



            </tbody>
          </table>


          <table className="form-table">

            <tbody>


              <tr><th colSpan="4"><span className='bold'>6.</span> Local (Current) Address</th></tr>
              <tr>
                <td colSpan="2" >
                  <div style={{ display: "flex" }}>
                    <div className='heading'>House No. <br />
                      Sector/Village/Locality</div><p contentEditable={true} className="fromValue" style={{ flex: "1 1", marginLeft: "10px" }}>{locality ?? ""}</p>
                  </div>



                </td>
                <td colSpan="2"><div className='heading'>
                  Residing at current address since
                </div>
                  <div contentEditable={true} className="fromValue">

                  </div>
                </td>

              </tr>

              <tr>
                <td rowSpan="2" colSpan="2"><div className='heading'>Name of Landlord & Address</div>
                  <div contentEditable={true} className="fromValue" style={{ minHeight: "40px" }}>{
                    `${ownerName ? ownerName + "," : ""} ${addressLine ? addressLine + "," : ""} ${city ? city + "," : ""} ${state ? state + "," : ""} India, ${postalCode ?? ""}`
                  }
                  </div></td>
                <td className='heading'>Police Station</td>
                <td contentEditable={true} className="fromValue">{policeStation ?? ""}</td>
              </tr>
              <tr>

                <td className='heading' style={{ width: "116px" }}>Post Office</td>
                <td style={{ width: "40%" }} contentEditable={true} className="fromValue"></td>
              </tr>




              <tr>
                <td className='heading' colSpan="4">
                  <div style={{ display: "flex" }}>
                    <div className='heading'>Mobile No.</div><p contentEditable={true} className="fromValue" style={{ flex: "1 1", marginLeft: "10px" }}>{user?.mobileNumber ?? ""}</p>
                  </div>

                </td>

              </tr>
              <tr>
                <td className='heading' rowSpan={2} >Two Local References(Name, Address & Ph No.)</td>
                <td colSpan="3" contentEditable={true} className="fromValue">1. {localRefNumber?.[0] || ""}</td>

              </tr>
              <tr>

                <td colSpan="3" contentEditable={true} className="fromValue">2. {localRefNumber?.[1] || ""}</td>

              </tr>
            </tbody>
          </table>


          <table className="form-table">

            <tbody>


              <tr ><td colSpan="2" className='heading' style={{ width: "50%" }}><span className='bold'>7.</span> Nature of Employment
                <br />    (       <span className='small'>
                  Domestic Servant/Shop Employee/Industrial Worker/Choudida/Dhobi Tenda etc.</span>)
              </td>
                <td colSpan="2" >
                  <div className='heading bold'>Place of Work</div>
                  <div contentEditable={true} className="fromValue" style={{ minHeight: "40px" }}>
                    {user?.employmentNature ? (
                      <>
                        {user.employmentNature},{" "}
                        <br />
                      </>
                    ) : ""}
                    {user?.officeAddress ? `${user.officeAddress}, ` : ""}
                    {user?.officeNumber ? `${user.officeNumber},` : ""}
                  </div>
                </td>
              </tr>



            </tbody>
          </table>

          <table className="form-table">

            <tbody>


              <tr><th colSpan="4"><span className='bold'>8.</span> Particulars of previous Employment(<span className='small'>In case of  Employee</span>)</th></tr>
              <tr>
                <td className='heading' style={{ width: "200px" }}>Nature of Employment



                </td>
                <td colSpan="2" contentEditable={true} className="fromValue"></td>
              </tr>
              <tr>
                <td className='heading'>Address</td>
                <td colSpan="2" contentEditable={true} className="fromValue"></td>
              </tr>

              <tr>
                <td colSpan="4">
                  <div style={{ display: "flex" }}>
                    <div className='heading'>Particulars of previous Employment (<span className='small'>with Mobile No</span>)</div><p contentEditable={true} className="fromValue" style={{ flex: "1 1", marginLeft: "10px" }}></p>
                  </div>
                </td>

              </tr>
            </tbody>
          </table>


          <table className="form-table">

            <tbody>
              <tr><th colSpan="4" style={{ borderBottom: "none" }}><span className='bold'>9.</span> Particulars of Family Members Residing With the Tenant/Employee</th></tr>
              <tr>

                <td colSpan="4" style={{ padding: "0", border: "none" }} >
                  <table className="form-table" style={{ borderTop: "0", marginBottom: "0" }}>
                    <thead>
                      <tr>
                        <td style={{ width: "20px" }}>Sr.No</td>
                        <td>Name</td>
                        <td style={{ width: "60px" }}>Age</td>
                        <td style={{ width: "60px" }}>Occupation</td>
                        <td style={{ width: "80px" }}>Sex</td>
                        <td style={{ width: "120px" }}>Relation</td>
                        <td style={{ width: "120px" }}>Mobile No.</td>
                      </tr>
                    </thead>
                    <tbody>
                      {
                        count.map((_, index) => {
                          return (<tr key={index}>
                            <td >{index + 1}.</td>
                            <td contentEditable={true} className="fromValue"></td>
                            <td contentEditable={true} className="fromValue"></td>
                            <td contentEditable={true} className="fromValue"></td>
                            <td contentEditable={true} className="fromValue"></td>
                            <td contentEditable={true} className="fromValue"></td>
                            <td contentEditable={true} className="fromValue"></td>
                          </tr>)
                        })
                      }


                    </tbody>
                  </table>


                </td>
              </tr>
            </tbody>
          </table>
          <button className='print-button addMore' onClick={() => { setCount([...count, ""]) }}>Add More</button>

          <p className="disclaimer">
            This is only Information Form. I am getting his/her Police verification done separately by addressing the concerned jurisdiction SP (of permanent address) in the prescribed Proforma.
          </p>

          <div className="signature" style={{ marginLeft: "auto", width: "141PX" }}>
            <p>Signed by:</p>
            <p style={{ marginTop: "30px", whiteSpace: "nowrap" }}>(Employer / Landlord)</p>
            <p>Date: ................</p>
          </div>
        </div>
      </div>
    </div>
  );
};

export default TenantVerificationForm;


